import {createSelector} from 'reselect';
import {getActiveRoles, getActiveUsers, getProjectCompanies} from '../selectors/configuration-selectors';
import {getSimpleGroupedEntities} from '../../utils/assigned-to-helpers';

export const getIssuesPermissions = state => state.issuesPermissions.permissions;
export const isFetchingPermissions = state => state.issuesPermissions.isFetching;
export const getIssuesPermissionsFetchError = state => state.issuesPermissions.fetchError;
export const isBulkCreatingPermissions = state => state.issuesPermissions.isBulkCreating;
export const isUpdatingPermissions = state => state.issuesPermissions.isUpdating;
export const isDeletingPermissions = state => state.issuesPermissions.isDeleting;

export const getGroupedProjectActiveEntitiesPermissionsCandidates = createSelector(
  getActiveUsers,
  getProjectCompanies,
  getActiveRoles,
  getIssuesPermissions,
  (users, companies, roles, issuesPermissions) => {
    const existingIDs = issuesPermissions.map(permission => permission.subjectId);
    const filterByID = collection => collection.filter(item => !existingIDs.includes(item.id));

    const filteredUsers = filterByID(users);
    const filteredCompanies = filterByID(companies);
    const filteredRoles = filterByID(roles);
    return getSimpleGroupedEntities({
      users: filteredUsers,
      companies: filteredCompanies,
      roles: filteredRoles
    });
  }
);
